import { render } from "./showPaiement.vue?vue&type=template&id=37a7dbc6&scoped=true"
import script from "./showPaiement.vue?vue&type=script&lang=js"
export * from "./showPaiement.vue?vue&type=script&lang=js"

import "./showPaiement.vue?vue&type=style&index=0&id=37a7dbc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a7dbc6"]])

export default __exports__